<div class="modal-header">
    <h4>Comentario</h4>
</div>
<div class="modal-body">
    <textarea style="min-width: 100%" rows="5" disabled="true">{{comentario}}</textarea>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="this.activeModal.dismiss()">Cancelar</button>
</div>